import React from 'react'
import LogoTransfix from 'transfix-ui/components/LogoTransfix'
import { makeStyles } from 'transfix-ui/core/styles'
import { App } from './App'

const useStyles = makeStyles(() => ({
  container: {
    fontFamily: 'Nunito Sans',
    backgroundColor: '#22292b',
    minHeight: '100vh',
    width: '100vw',
    paddingTop: '80px',
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  appContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingLeft: '20px',
    paddingRight: '20px',
  },
}))

function ProductDemos() {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.logoContainer}>
        <LogoTransfix color='white' />
      </div>
      <div className={classes.appContainer}>
        <App />
      </div>
    </div>
  )
}

export default ProductDemos
